// Top-level results data source — single choke point for the
// real-vs-demo branch. Every public results widget reads through
// here so the demo/real isolation contract has exactly one home.
//
// Contract (see src/data/demo/contract.ts):
//   · `results_demo_mode === 'live'` → demo dataset, banner shown.
//   · otherwise → real DB-backed data (empty defaults until editor
//     enters anything in /admin/results).
//   · The hero winner (Hero.tsx → useElectionDayEditorial.nationalCall)
//     is REAL ONLY, regardless of this toggle.

import { useElectionDayResults } from '../../lib/useElectionDayResults';
import { useResultsDemoMode } from '../../data/demo/contract';
import {
  emptyResultsState,
  type ResultsState,
} from '../../data/electionday-results-types';
import { getDemoResultsState } from '../../data/demo/results.demo';

export interface ResultsDataView {
  data: ResultsState;
  isDemo: boolean;
  isLoading: boolean;
}

export function useResultsData(): ResultsDataView {
  const isDemo = useResultsDemoMode();
  const { data, isLoading } = useElectionDayResults({ refreshInterval: 12_000 });

  if (isDemo) {
    return { data: getDemoResultsState(), isDemo: true, isLoading: false };
  }
  return {
    data: data ?? emptyResultsState(),
    isDemo: false,
    isLoading,
  };
}
